import styled from '../../config/theme'

const Img = styled.img`
  vertical-align: middle;

  border-radius: 128px;
  object-fit: cover;
`

export {
  Img,
}
